/**
 * consists all the api mapping (routes)
 */
export const APIMapping = {
  GET_STATIONS: '/station',
  GET_STATION_BY_ID: '/station/:id',
  ADD_STATION: '/station',
  // UPLOAD_SIP_AND_GRADIENT: '/file_analysis',
  UPLOAD_SIP_AND_GRADIENT: '/file_analysis_async',
  GET_PROCESSING_STATUS: '/get_processing_status',
  GET_TRACKS: '/get_track_details',
  ADD_TRACK: '/add_track_details',
  ADD_STATION_SURVERY: '/add_station_survey',
  GET_PIM_IMAGE: '/get_sip_image',
  GET_PIM_PDF: '/get_gradient_pdf',
  POST_EDIT_TABLE_DATA:'/edit_station_data',
  FETCH_SURVEY_META_FILES: '/get_station_meta_files',
  GET_PIM_SIP_FILE: '/get_sip_image',
  GET_PIM_GRADIENT_FILE: '/get_gradient_file',
  GET_PIM_SIGNALLING_FILE: '/get_signal_toc_pdf',
  GET_CHILD_ROLE_USERS:'/users/get-child-role-users/:current_user_role_id',
  GET_PARENT_ROLE_USERS: '/users/get-parent-role-users/:current_user_role_id',
  UPDATE_STATION_STATUS:'/update_station_status',
  GET_STATION_VERSIONS:'/get_station_versions_metadata',
  GET_STATION_VERSION_FILE:'/get_station_version_file',
  GET_ALL_SELECTED_STATIONS_FILES:'/get_all_version_files',
  ADD_SIGN_TOC:'/add_sign_toc',
  ADD_SIGN_TRACK_PROFILE_DATA:'/add_sign_track_profile_data',
  ADD_SIGN_TINS_PDF:'/embed_signature_in_tins_pdf',
  ADD_SIGN_RADIO_PDF:'/embed_signature_in_radio_design',
  ADD_SIGN_RFID_TAG_DATA:'/embed_signature_in_rfid_tag',
  PLOT_OR_UPDATE_SIP: '/plot_or_update_sip_layout',
  GENERATE_COMMENTS: '/generate_comment',

  //comments
  GET_COMMENTS:'/fetch_comments',
  ADD_COMMENT:'/add_comment',
  UPDATE_COMMENT:'/update_comment',
  DELETE_COMMENT:'/delete_comment',
  ADD_REPLY:'/add_comment',

  ADD_STATION_DATA:'/update_station_master_data',

  //ZONE RULES
  GET_OEM_RULES: '/metadata/oem',
  GET_ALL_ZONES: '/metadata/zone',
  GET_ZONE_RULES_TABLE: '/rules/fetch_paginated_rule_value_applicability',
  GET_RULE_TYPES: '/rules/rule_type',
  GET_RULE_CATEGORIES: '/rules/rule_category',
  UPDATE_RULE:'/rules/rule',
  DELETE_RULE:'/rules/rule/:rule_id',
  GET_SUB_TRACKS: '/get_sub_track_details',
  ADD_SUB_TRACK: '/add_sub_track_details',
  SAVE_SUB_TRACK_DATA: '/add_station_track_subtrack_mapping_details',
  SAVE_SURVEY_DRAFT: '/save_survey_draft',
  PROCESS_SURVEY_FILE_FIRST_PASS: '/process_survey_file_first_pass',
  PROCESS_SURVEY_FILE_SECOND_PASS: '/process_survey_file_second_pass',
  GET_LAYOUT_EDIT_STATUS:'/get_station_layout_lock_status',
  UPDATE_LAYOUT_EDIT_STATUS:'/set_station_layout_edit_status',
  UPDATE_DRAFT_ACCESS_STATUS:'/update_draft_access_status',
  GENERATE_TOC_DOC: '/generate_toc_doc',
  GENERATE_TPT_DOC: '/generate_tpt_doc',
  GET_ZONE_LIST: '/get_toc_zones',
  GET_VENDOR_LIST: '/get_toc_vendors',
  GET_HEADER_TYPES: '/get_toc_types',
  CREATE_OR_UPDATE_TOC_HEADER: '/save_toc_header',
  GET_TOC_HEADER_DATA: '/get_toc_header',
  UPDATE_SIGNALLING_TOC_DATA: '/update_signal_toc_data',
  GET_TOC_CHEAT_SHEET_PDF: '/get_header_cheat_sheet',

  LOCK_STATION_LAYOUT:'/lock_station_layout',
  UNLOCK_STATION_LAYOUT:'/unlock_station_layout',
  REFRESH_STATION_LAYOUT_LOCK:'/refresh_station_layout_lock',
  GET_DB_FILE_DOWNLOAD: '/get_db_file_path',
  ON_GRADIENT_FILE_UPLOAD: '/file_analysis_async_gradient_file',
  COPY_SURVEY_DRAFT: '/clone_survey_draft',
  EXTRACT_PSR_EXCEL: '/extract_psr_excel',
  GET_ALL_TAG_DATA: '/get_rfid_tag_data_json',
  GET_STATION_IP_ADDRESS: '/get_station_ip_address',
  ZONE_VENDOR_TYPE_DELETE: '/delete_from_tocdb',
  GET_ZONES: '/get_zones',
  GET_DIVISIONS: '/get_divisions',
  GET_STATIONS_LIST: '/get_stations',
  DELETE_STATION_MASTER_DATA:'/delete_station_master_data',
  GET_TRACK_WITH_ADJUSTMENT: '/get_tracks_with_adjustments',
  SLF_CTF_FILE_UPLOAD: '/generate_slf_and_ctf_files',
  GET_SLF_CTF_FILES_DATA: '/get_slf_and_ctf_file_paths',
  GAP_INTERVAL_ANALYZER: '/gap_interval_analyzer',
  GET_LAYOUT_VERSIONS: '/station-layouts/version',
  GET_LAYOUT_VERSION_DATA: '/station-layouts/undo',
  GET_LAYOUT_SUBMISSION_STATUS: '/layout_submission_status/:station_uuid',
  APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA: '/apply_anti_collision_on_red_and_green_data',
}
